import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

const recentJoins = [
  { name: "Priya", location: "Mumbai", time: "Just now" },
  { name: "Rahul", location: "Delhi", time: "20 mins ago" },
  { name: "Neha", location: "Bengaluru", time: "45 mins ago" },
  { name: "Ankit", location: "Pune", time: "1 hour ago" },
  { name: "Divya", location: "Chennai", time: "1.5 hours ago" },
  { name: "Sameer", location: "Jaipur", time: "2 hours ago" },
  { name: "Ritu", location: "Kolkata", time: "2.5 hours ago" },
  { name: "Karan", location: "Hyderabad", time: "3 hours ago" },
];

const DISMISS_KEY = "ax_social_proof_dismissed";

export const SocialProofToast = () => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(DISMISS_KEY)) {
      setDismissed(true);
      return;
    }
    const showTimer = setTimeout(() => setVisible(true), 6000);
    return () => clearTimeout(showTimer);
  }, []);

  useEffect(() => {
    if (dismissed || !visible) return;
    const hideTimer = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, dismissed]);

  useEffect(() => {
    if (dismissed || visible) return;
    const nextTimer = setTimeout(() => {
      setIndex((i) => (i + 1) % recentJoins.length);
      setVisible(true);
    }, 9000);
    return () => clearTimeout(nextTimer);
  }, [visible, dismissed]);

  const handleClose = () => {
    setVisible(false);
    setDismissed(true);
    sessionStorage.setItem(DISMISS_KEY, "1");
  };

  if (dismissed) return null;
  const person = recentJoins[index];

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -40 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          data-testid="social-proof-toast"
          className="fixed left-4 bottom-24 lg:bottom-6 z-30 max-w-xs bg-[#0d0d10]/95 backdrop-blur-xl border border-white/10 rounded-2xl px-4 py-3 shadow-[0_10px_40px_rgba(0,0,0,0.5)] flex items-start gap-3"
        >
          <span className="relative mt-1 flex h-2.5 w-2.5 shrink-0">
            <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 animate-ping" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-500" />
          </span>
          <div className="flex-1">
            <p className="text-sm text-white leading-snug">
              <span className="font-semibold">{person.name}</span> from {person.location} just joined AX Academy
            </p>
            <p className="mt-0.5 text-xs text-zinc-500 font-mono">{person.time}</p>
          </div>
          <button
            onClick={handleClose}
            data-testid="social-proof-toast-close"
            className="text-zinc-500 hover:text-white shrink-0"
            aria-label="Dismiss notification"
          >
            <X size={14} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
